import { atom } from 'jotai';
import { atomWithObservable } from 'jotai/utils';
import { Observable } from 'rxjs';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from 'utils/firebase';

const authState$ = new Observable<User | null | undefined>((subscriber) => {
  subscriber.next(undefined);
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    subscriber.next(user);
  });
  return () => unsubscribe();
});

export const authUserAtom = atomWithObservable<User | null | undefined>(() => authState$);
export const isAuthLoadingAtom = atom((get) => get(authUserAtom) === undefined);
